var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckboxGroup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 160,
    viewBox: "0 0 320 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 304,
    height: 152,
    transform: "translate(8 8)",
    fill: "#A5B0B7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87 90.6155C87 86.1972 90.5817 82.6155 95 82.6155H123C127.418 82.6155 131 86.1972 131 90.6155V118.615C131 123.034 127.418 126.615 123 126.615H95C90.5817 126.615 87 123.034 87 118.615V90.6155Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M134 79L139.665 84.6486L109.165 114.96L103.5 109.311L134 79Z",
    fill: "#4C6170"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M92 98L97.6743 92.3607L114.67 109.306L108.995 114.946L92 98Z",
    fill: "#4C6170"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.23 82.7095C123.829 82.6476 123.418 82.6155 123 82.6155H95C90.5817 82.6155 87 86.1972 87 90.6155V118.615C87 123.034 90.5817 126.615 95 126.615H123C127.418 126.615 131 123.034 131 118.615V98.5389L127 102.514V118.615C127 120.825 125.209 122.615 123 122.615H95C92.7909 122.615 91 120.825 91 118.615V90.6155C91 88.4063 92.7909 86.6155 95 86.6155H120.3L124.23 82.7095Z",
    fill: "#4C6170"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M147 99H234V111H147V99Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M87 38.6155C87 34.1972 90.5817 30.6155 95 30.6155H123C127.418 30.6155 131 34.1972 131 38.6155V66.6155C131 71.0338 127.418 74.6155 123 74.6155H95C90.5817 74.6155 87 71.0338 87 66.6155V38.6155Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M134 27L139.665 32.6486L109.165 62.9599L103.5 57.3113L134 27Z",
    fill: "#4C6170"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M92 46L97.6743 40.3607L114.67 57.3065L108.995 62.9458L92 46Z",
    fill: "#4C6170"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.23 30.7095C123.829 30.6476 123.418 30.6155 123 30.6155H95C90.5817 30.6155 87 34.1972 87 38.6155V66.6155C87 71.0338 90.5817 74.6155 95 74.6155H123C127.418 74.6155 131 71.0338 131 66.6155V46.5389L127 50.5142V66.6155C127 68.8246 125.209 70.6155 123 70.6155H95C92.7909 70.6155 91 68.8246 91 66.6155V38.6155C91 36.4063 92.7909 34.6155 95 34.6155H120.3L124.23 30.7095Z",
    fill: "#4C6170"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M147 47H234V59H147V47Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 151,
    width: 304,
    height: 9,
    fill: "#B4DDEB"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxGroup);
export default __webpack_public_path__ + "static/media/checkbox-group.6555895576662e978c8ef0c96721075f.svg";
export { ForwardRef as ReactComponent };